module.exports = __webpack_public_path__ + "img/convenience-2-supp.ac49a0b3.png";